import { useParams, Navigate, useLocation } from "react-router-dom";

interface DynamicRedirectProps {
  paramKey?: string;
  destination: string;
}

export const DynamicRedirect = ({ paramKey, destination }: DynamicRedirectProps) => {
  const params = useParams();
  const location = useLocation();

  if (!paramKey) {
    return <Navigate to={destination} replace state={{ from: location }} />;
  }

  const paramValue = params[paramKey];
  if (!paramValue) {
    return <Navigate to="/not-found" replace />;
  }

  const finalPath = destination.replace(`:${paramKey}`, paramValue);
  return <Navigate to={finalPath} replace state={{ from: location }} />;
};
